import { ValueDisplay } from '../../components/ValueDisplay'
import LineDisplay from './LineDisplay'
import { Input } from "baseui/input";
import { LabelMedium } from 'baseui/typography';
import { Block } from 'baseui/block';
import { IFG_SAUTER_CoolingSetpoint } from './types'
// api
import { useSetObjectValue } from '../../../hooks/useSetObjectValue';
import { FormattedMessage } from 'react-intl';

export const OperatorPanel = (props: IFG_SAUTER_CoolingSetpoint) => {

    const [minOutTCooling, setMinOutTCooling, setMinOutTCoolingResult] = useSetObjectValue(props.id, props.resourceGroupId, "minOutTCooling", props.minOutTCooling);
    const onMinOutTCoolingChanged = (e: any) => setMinOutTCooling(parseFloat(e.target.value));

    return (

        <>
            <>
                <ValueDisplay value={props.actSetpoint} dimension={'°C'}></ValueDisplay>
            </>

            <LineDisplay {...props}> </LineDisplay>

            <Block gridRowGap='20px' display='flex'flexDirection='column' >
                <LabelMedium><FormattedMessage id="FG_SAUTER_CoolingSetpoint.minOutTCooling" defaultMessage="Minimum outside temperature for cooling" /></LabelMedium>
                <Input
                    value={minOutTCooling}
                    onChange={onMinOutTCoolingChanged}
                    placeholder=""
                    disabled={setMinOutTCoolingResult.isLoading}
                    error={setMinOutTCoolingResult.isError}
                />
            </Block>
        </>
    )
}

